import React from 'react';
import { useTable } from 'hooks';
import { Page, BooleanIcon } from 'components/common';
import { Table } from 'reactstrap';

export const List = () => {
  const {
    Pagination,
    ViewingRecords,
    TableContainer,
    TableSearch,
    TableDataFetch,
    data,
    EditDeleteButtons,
    AddNewButton,
    BulkDeleteButton
  } = useTable({
    match: {url: 'white-label-partners'},
    resource: 'White Label Partners',
    url: 'white-label-partners'
  });

  return (
    <Page title="White Label Partners">
      <div className="d-flex justify-between mb-3">
        <AddNewButton />
        <BulkDeleteButton className='ml-3'/>
      </div>
      <TableContainer>
        <Table>
          <thead>
            <tr>
              <th select />
              <th>Name</th>
              <th/>
            </tr>
          </thead>
          <tbody>
            {data.results.map(i => (
              <tr key={i.id}>
                <td select />
                <td>{i.name} {i.default ? '(*default)' : ''}</td>
                <td>
                  <EditDeleteButtons id={i.id} />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>
      <div className="flex justify-between">
        <ViewingRecords />
        <Pagination />
      </div>

      <TableDataFetch />
    </Page>
  );
};

export default List;



// WEBPACK FOOTER //
// ./src/pages/WhiteLabelPartners/List.js